import { FaShippingFast } from "react-icons/fa";
import { PeriodProvider } from "@/providers/Period";
import { BreadcrumbProvider } from "@/providers/Breadcrumb";
import { lazy } from "react";

const MovimentacoesDashboard = lazy(() => import("./Dashboard").then((m) => ({ default: m.MovimentacoesDashboard })));
const ExtratoMovimentcao = lazy(() => import("./Extrato"));
// import ProductivityDashboard from "./Produtividade";
const ExtratoMovimentacaoTMC = lazy(() => import("./ExtratoTmc"));
const Gestao = lazy(() => import("./GestaoMovimentacao"));
const RelatorioMovimentacao = lazy(() => import("./RelatorioMovimentacao"));

const Module = {
  menuItem: {
    to: "/movimentacoes",
    title: "Movimentações",
    icon: FaShippingFast,
    id: 10,
    childrens: [
      {
        to: "/movimentacoes/gestao",
        title: "Gestao",
        fullTitle: "Gestao",
        id: 28,
      },
      {
        to: "/movimentacoes/extrato",
        title: "Extrato",
        fullTitle: "Extrato Movimentação",
        id: 29,
      },
      {
        to: "/movimentacoes/extrato-movimentacao-container",
        title: "Extrato Container",
        fullTitle: "Extrato Movimentação Container",
        id: 47,
      },
      // {
      //   to: "/movimentacoes/produtividade",
      //   title: "Produtividade",
      //   fullTitle: "Produtividade",
      //   id: 21
      // },
      {
        to: "/movimentacoes/relatorio-movimentacao",
        title: "Relatório de Movimentação",
        fullTitle: "Relatório de Movimentação",
        id: 30,
      },
    ],
  },

  routes: [
    {
      path: "movimentacoes",
      element: <MovimentacoesDashboard />,
    },
    {
      path: "/movimentacoes/extrato",
      element: <ExtratoMovimentcao />,
    },
    {
      path: "/movimentacoes/extrato-movimentacao-container",
      element: <ExtratoMovimentacaoTMC />,
    },
    {
      path: "/movimentacoes/gestao",
      element: (
        <PeriodProvider>
          <BreadcrumbProvider>
            <Gestao />
          </BreadcrumbProvider>
        </PeriodProvider>
      ),
    },
    // {
    //   path: "/movimentacoes/produtividade",
    //   element: (
    //     <ProductivityDashboard />
    //   ),
    // },
    {
      path: "/movimentacoes/relatorio-movimentacao",
      element: <RelatorioMovimentacao />,
    },
  ],
};

export default Module;
